/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PortfolioEvaluationItemPlanEvaluationType =
  (typeof PortfolioEvaluationItemPlanEvaluationType)[keyof typeof PortfolioEvaluationItemPlanEvaluationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PortfolioEvaluationItemPlanEvaluationType = {
  Match: "Match",
  Missmatch: "Missmatch",
  OutOfMarket: "OutOfMarket",
} as const;
